import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

type Props = { code: string };

export const EmploymentDataTrialPeriod = ({ code }: Props) => {
  const { t } = useTranslation();

  const trialPeriodOptions = [1, 2, 3, 4, 5, 6].map((count) => ({
    code: `P${count}M`,
    name: `${count} ${t(count > 1 ? 'laMonths' : 'laMonth')}`,
  }));

  const selectedOption = trialPeriodOptions.find(
    (option) => option.code === code,
  );

  return <Box component="span">{selectedOption?.name ?? ''}</Box>;
};
